export function computeClosestFutureExpiry(dates) {
  try {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const rawList = Array.isArray(dates) ? dates : dates ? [dates] : [];
    const list = rawList
      .map((d) => (d instanceof Date ? d : new Date(d)))
      .filter((d) => !Number.isNaN(d?.getTime?.()))
      .sort((a, b) => a - b);
    const future = list.filter((d) => d >= today);
    return future.length ? future[0] : null;
  } catch {
    return null;
  }
}
